
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.34 1.85a14.83 14.83 0 00-11.63 24l-2.08 5 5.13-2.13a14.84 14.84 0 108.58-26.87z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M30.84 21.13a8.53 8.53 0 015.81 13.79l1.2 2.88-3-1.22a8.53 8.53 0 01-13.26-5.11","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"16.34","cy":"16.69","r":"9.25","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"12.26","cy":"15.02","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"20.42","cy":"15.02","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"d":"M20.77 18.67a4.81 4.81 0 01-8.85 0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    